import { Cell } from 'rsuite-table'
import { Button } from 'rsuite'

const ApproveCell = ({ rowData, onApproveClick, ...props }: any) => {
  return (
    <Cell {...props} style={{ textAlign: 'center' }}>
      <Button
        appearance="primary"
        color="green"
        onClick={() => onApproveClick(rowData)}
        disabled={rowData.status === 'RESOLVED'}
      >
        {rowData.status === 'RESOLVED' ? 'Updated' : 'Update'}
      </Button>
    </Cell>
  )
}

export default ApproveCell
